module.exports = __webpack_public_path__ + "media/images/default/lp_feature_3-24c977ebf1236b12c73c1baf5fe8b11d.svg";